export const MESSAGE_ALERT_HEADER_NAME = 'x-tupago1app-alert';
export const MESSAGE_ERROR_HEADER_NAME = 'x-tupago1app-error';
export const MESSAGE_PARAM_HEADER_NAME = 'x-tupago1app-params';

export const AUTHENTICATION_TOKEN_KEY = 'jhi-authenticationToken';

export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
}
